import { useMemo } from 'react'
import { TableHeaderDef } from '../../../../../../containers/SingleSheetV2/table/model'
import { intl } from '../../../../../../../i18n'

export const useBasicInformation = () => {
  const tableHeaderDef = useMemo<TableHeaderDef>(() => {
    return {
      externalId: 'basicInformation',
      label: intl.formatMessage({ id: 'wbsItem.basicInformation' }),
    }
  }, [])
  return tableHeaderDef
}
export const useAssignment = () => {
  const tableHeaderDef = useMemo<TableHeaderDef>(() => {
    return {
      externalId: 'assignment',
      label: intl.formatMessage({ id: 'wbsItem.assignment' }),
    }
  }, [])
  return tableHeaderDef
}
export const usePlanning = () => {
  const tableHeaderDef = useMemo<TableHeaderDef>(() => {
    return {
      externalId: 'planning',
      label: intl.formatMessage({ id: 'wbsItem.planning' }),
    }
  }, [])
  return tableHeaderDef
}
export const useUpdatedInfo = () => {
  const tableHeaderDef = useMemo<TableHeaderDef>(() => {
    return {
      externalId: UPDATED_INFO_TABLE_HEADER_EXTERNAL_ID,
      label: intl.formatMessage({ id: 'wbsItem.updateInfo' }),
    }
  }, [])
  return tableHeaderDef
}
export const UPDATED_INFO_TABLE_HEADER_EXTERNAL_ID = 'updateInfo'
